import React, { useCallback, useMemo, useState } from 'react';

import StartTrialDialog from '../components/StartTrialDialog';

export default function useStartTrialDialog() {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    const dialog = useMemo(() => <StartTrialDialog open={isOpen} onClose={close} />, [close, isOpen]);

    return [dialog, open, close] as const;
}
